/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Wed Feb 22 2023 3:16:54 PM
 *
 *******************************************************/
//@flow

import React, { Component } from 'react';
import { Icon, Link, Badge } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';
import { LockMinor, ExternalSmallMinor } from '@shopify/polaris-icons';
import { URL } from 'src/constants/links';
import { AdvanceSearchFeaturePreview } from 'src/constants/search';
import { Carousel } from 'src/components/views/common/carousel';
import Rocket from 'src/assets/images/common/rocket.svg';
import FlatIcon from 'src/assets/images/common/flat-icon.png';

class PremiumLockCard extends Component<Props> {
  render() {
    const { i18n, disableLockUnLock, isSubscribeNow } = this.props;

    const elements = AdvanceSearchFeaturePreview.map(feature => this.renderFeatureCard(feature));

    // Boost search campaign discount - until 15/04
    const today = new Date().getTime() / 1000;
    const searchCampaign = {
      content: (
        <div>
          <p>
            {i18n.translate('AdminHTML.AdvanceSearch.CampaignSearch.contentCard01', {
              t1: (
                <strong>
                  {i18n.translate('AdminHTML.AdvanceSearch.CampaignSearch.contentCard01_t1')}
                </strong>
              )
            })}
          </p>
          <p>
            {i18n.translate('AdminHTML.AdvanceSearch.CampaignSearch.contentCard02', {
              t1: (
                <strong>
                  {i18n.translate('AdminHTML.AdvanceSearch.CampaignSearch.contentCard02_t1')}
                </strong>
              ),
              t2: (
                <i>
                  {i18n.translate('AdminHTML.AdvanceSearch.CampaignSearch.contentCard02_t2')}
                </i>
              )
            })}
          </p>
        </div>
      ),
      date: new Date('2024-04-15 23:59').getTime() / 1000
    };

    return (
      <div className="premium-lock-card premium-lock-advanced-search">
        <div className="badge-ai">
          <Badge>
            <img width={12} height={12} src={FlatIcon} alt="wand" />
            <span>{i18n.translate('AdminHTML.AdvanceSearch.iconText02')}</span>
          </Badge>
        </div>
        <div className="heading">
          {i18n.translate('AdminHTML.AdvanceSearch.PremiumFeature02.title')}
          <img src={Rocket} alt="rocket" width={24} height={24} />
        </div>

        {searchCampaign.date >= today ? (
          searchCampaign.content
        ) : (
          <p>{i18n.translate('AdminHTML.AdvanceSearch.PremiumFeature02.content')}</p>
        )}

        <div className="action">
          <div
            className={`Polaris-Button ${disableLockUnLock ? 'unlock-button-disabled' : ''}`}
            onClick={this.handleUnlock}>
            <Icon source={LockMinor} />
            {i18n.translate(
              `AdminHTML.Common.Action.${isSubscribeNow ? 'unLockNow' : 'unlockFeatureForTrial'}`
            )}
          </div>
          <Link external url={URL['Link_V2_AI_Search_Doc']}>
            {i18n.translate('AdminHTML.Common.Action.learnMore')}
            <Icon source={ExternalSmallMinor} color={'interactive'}></Icon>
          </Link>
        </div>
        <div className="feature-list">
          <Carousel items={elements} hideAction={true} hasSlideControls={true} />
        </div>
      </div>
    );
  }

  // Render feature card
  renderFeatureCard = data => {
    const { i18n } = this.props;
    const { name, image, title, content } = data;

    return (
      <div key={name} className="feature-search-card">
        <div className="image">
          <img src={image} alt={i18n.translate(title)} width={332} height={200} />
        </div>
        <div className="content">
          <div>{i18n.translate(title)}</div>
          <p>{i18n.translate(content)}</p>
        </div>
      </div>
    );
  };

  handleUnlock = () => {
    const { action, disableLockUnLock } = this.props;
    if (disableLockUnLock) return;
    action();
  };
}

export default withI18n()(PremiumLockCard);
